module.exports = __webpack_public_path__ + "img/57.c3081bd6.jpg";